import React from 'react';

import {AthletePropositionBetModuleProps} from "../models/athlete-proposition-bet-module.props";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {AthletePropositionBetModuleController} from "../athlete-proposition-bet-module.controller";
import styles from "../styles/athlete-proposition-bet.module.scss";
import classNames from "classnames";
import {CardTitleWrapper} from "../../../core/components/misc/card-tite/card-title.wrapper";
import {AthletePropositionBetModuleContent} from "./athlete-proposition-bet-module.content";
import {Loader} from "../../../core/components/loading/loader";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";

export class PropositionBetsDetailsModuleComponentProps extends AthletePropositionBetModuleProps {}

export const PropositionBetsDetailsModuleComponent = ({controller, isPopup}: PropositionBetsDetailsModuleComponentProps) => {
  const {state, device} = controller;
  const {isSmallView} = device;
  const {row, title, bookmaker} = state;

  const loaderProps = {
    when: state.fetchingState === FETCHING_STATES.fetching || state.componentState === COMPONENT_STATES.loading,
    className: classNames(styles.placeholder, {[styles.small_view]: isSmallView})
  }
  const shouldRenderActionButton = bookmaker?.actionButton;

  const wrapperProps = {
    className: classNames(styles.container, {[styles.small_view]: isSmallView, [styles.under_over_bet]: row.isUnderOver, [styles.no_bookie]: !shouldRenderActionButton, [styles.popup]: isPopup}),
    controller,
    title
  }

  return (
    <Loader {...loaderProps}>
      <CardTitleWrapper {...wrapperProps}>
        <AthletePropositionBetModuleContent controller={controller} row={row}/>
      </CardTitleWrapper>
    </Loader>
  )
};

const settings: ComposeSettings = {
  component: PropositionBetsDetailsModuleComponent,
  propsType:
  PropositionBetsDetailsModuleComponentProps,
  controllerType:
  AthletePropositionBetModuleController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,
  observe: true,
};

export default Compose(settings);
